import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CarInsurance from '../../../assets/images/svg/car-insurance.svg'
import ApartmentInsurance from '../../../assets/images/svg/apartment.svg'
import FamilyInsurance from '../../../assets/images/svg/family-insurance.svg'
import HealthProtection from '../../../assets/images/svg/health-protection.svg'
import HomeInsurance from '../../../assets/images/svg/home-insurance.svg'
import FinancialInsurance from '../../../assets/images/svg/financial-insurance.svg'
import Faq from '../../../assets/images/faq.png'
import "./GetAQuote.scss"

const cards = [
    { label: "Car Insurance", icon: CarInsurance },
    { label: "Renters Insurance", icon: ApartmentInsurance },
    { label: "Home Insurance", icon: HomeInsurance },
    { label: "Life Insurance", icon: FamilyInsurance },
    { label: "Financial Insurance", icon: FinancialInsurance },
    { label: "Health Insurance", icon: HealthProtection },
];

const faqs = [
    {
        question: "Why do I need an insurance policy?",
        answer:
            "Insurance protects you from unexpected financial losses, giving you peace of mind in case of accidents, damages, or emergencies.",
    },
    {
        question: "How does insurance work?",
        answer:
            "You pay a regular premium to the insurer, and in return, the insurer covers certain losses or damages as outlined in your policy.",
    },
    {
        question: "Does car insurance follow the car or you, the policy holder?",
        answer:
            "Car insurance usually follows the policyholder, but coverage specifics can depend on your policy and local regulations.",
    },
    {
        question: "What is a deductible in an insurance policy?",
        answer:
            "A deductible is the amount you pay out of pocket before your insurance kicks in. Choosing a higher deductible usually lowers your premium.",
    },
    {
        question: "Is it possible to have multiple insurance policies?",
        answer:
            "Yes. You can hold multiple policies for different types of coverage. However, having duplicate coverage for the same risk may be unnecessary.",
    },
    {
        question: "What happens if I miss a premium payment?",
        answer:
            "Missing a payment could result in a lapse of coverage. Some insurers offer grace periods, but it's best to pay on time to avoid losing protection.",
    }
];

export default function GetAQuoteComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [showPreview, setShowPreview] = useState(false);

    const toggle = (idx) => {
        if (activeIndex !== idx) {
            setActiveIndex(idx);
        }
    };

    const handleClick = (section) => {
        toast.warning(`${section} service is not activated for your banking account. Please leave an appointment with a banking expert to manage service access.`);
    }

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel">
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>FLEXIBLE INSURANCE QUOTES</h5>
                    <p className="text-muted">
                        Our flexible insurance quotes are tailored to your profile, allowing you to choose the coverage that best fits your financial needs with transparent terms and fair pricing.
                    </p>

                    <h4 className="text-center my-5">What we offer?</h4>

                    <div className="d-flex justify-content-center flex-wrap gap-3">
                        {cards.map(({ label, icon }) => (
                            <div className="d-flex flex-wrap justify-content-center gap-4 my-4">
                                <div
                                    key={label}
                                    className="card text-center p-3 rounded"
                                    style={{ width: "160px", cursor: "pointer" }}
                                >
                                    <div className="mb-3 d-flex justify-content-center">
                                        <img
                                            src={icon}
                                            alt={`${label} icon`}
                                            style={{ width: "48px", height: "48px", objectFit: "contain" }}
                                        />
                                    </div>
                                    <div className="fw-semibold">{label.toLocaleUpperCase()}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="my-5 text-center">
                        <button className={`btn btn-primary ${isMobile ? "w-100" : "w-20"}`} onClick={() => handleClick('Insurance Quote')}>
                            Get a quote
                        </button>
                    </div>

                    <div className="d-flex justify-content-between m-auto my-5" style={{ maxWidth: '1400px' }}>
                        <div className='row'>
                            <div className="col-md-6">
                                <h3 className={`${isMobile ? "text-center" : "text-start"}`}>Get your question answered</h3>
                                <p className={`text-muted mb-4 ${isMobile ? "text-center" : "text-start"}`}>
                                    Insurance doesn't have to be confusing.
                                </p>

                                <div className="accordion" id="faqAccordion">
                                    {faqs.map(({ question, answer }, idx) => (
                                        <div className="accordion-item" key={idx}>
                                            <h2 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${activeIndex === idx ? '' : 'collapsed'}`}
                                                    onClick={() => toggle(idx)}
                                                >
                                                    {question}
                                                </button>
                                            </h2>
                                            <div className={`accordion-collapse collapse ${activeIndex === idx ? 'show' : ''}`}>
                                                <div className="accordion-body">
                                                    {answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-5 text-start">
                                    <button className={`btn btn-primary w-100`} onClick={() => navigate("/request-appointment")}>
                                        More questions? Leave a clarifying appointment.
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-6 d-flex justify-content-center">
                                <img
                                    src={Faq}
                                    alt="Cartoon Insurance Icon"
                                    style={{ maxWidth: "580px", width: "100%", height: "auto", ...(isMobile ? { marginTop: "20px" } : {}) }}
                                />
                            </div>
                        </div>
                    </div>

                    <h5 className='text-center my-5'>Learn more about Bancassurance</h5>
                    <div className="container my-5" style={{ maxWidth: '1400px' }}>
                        <img
                            src='https://artesiab.com/wp-content/uploads/2025/07/Frame-35-2-1-3.png'
                            alt="Insurance Quote"
                            className="img-fluid w-100 rounded shadow"
                            onClick={() => isMobile && setShowPreview(true)}
                            style={{
                                cursor: isMobile ? 'zoom-in' : 'default',
                                ...(isMobile ? {} : { maxWidth: "100%", height: "auto", objectFit: "cover" })
                            }}
                        />
                    </div>

                </div>
            </div >

            {isMobile && showPreview && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        zIndex: 9999,
                    }}
                    onClick={() => setShowPreview(false)}
                >
                    <img
                        src="https://artesiab.com/wp-content/uploads/2025/07/Frame-35-2-1-3.png"
                        alt="Preview Zoom"
                        className="img-fluid rounded"
                        style={{
                            maxHeight: '97%',
                            maxWidth: '97%',
                            objectFit: 'contain',
                            boxShadow: '0 0 20px rgba(255,255,255,0.2)',
                        }}
                    />
                </div>
            )}
        </>
    );
}